<template>
  <v-layout wrap v-if="types && content">
    <v-flex xs12 style="margin-top:10px;">
      <v-select
        v-if="types"
        outlined
        hide-details
        v-model="content.TypeShow"
        :items="types"
        item-text="Name"
        item-value="ID"
        :label="$t('dtouch.activities.types', locale)"
        @change="handleChangeIsModified"
      />
    </v-flex>
    <v-flex xs12 style="margin-top: 10px;">
      <color-picker-item
        :value="content.ShowPrimaryColor"
        :label="$t('dtouch.activities.primaryColor', locale)"
        :onChange="handleChangePrimaryColor"
        borderRadius="20px 0 0 0"
      />
    </v-flex>
    <v-flex xs12>
      <color-picker-item
        :value="content.ShowSecundaryColor"
        :label="$t('dtouch.activities.secondaryColor', locale)"
        :onChange="handleChangeSecundaryColor"
        borderRadius="0 0 0 0"
      />
    </v-flex>
    <v-flex xs12>
      <color-picker-item
        :value="content.ShowColor"
        :label="$t('dtouch.activities.titleColor', locale)"
        :onChange="handleChangeTitleColor"
        borderRadius="0 0 0 0"
      />
    </v-flex>
    <v-flex xs12>
      <color-picker-item
        :value="content.ShowDescriptionColor"
        :label="$t('dtouch.activities.descriptionColor', locale)"
        :onChange="handleChangeDescriptionColor"
        borderRadius="0 0 20px 0"
      />
    </v-flex>

  </v-layout>
</template>
<script>
import { mapState } from 'vuex'
import utils from '@/services/utils'
import api from '@/services/api'
import ColorPickerItem from '@/components/common-components/ColorPickerItem'
export default {
  name: 'Form19Show',
  components: {
    ColorPickerItem,
  },
  props: {
    editedItem: {
      type: Object,
      required: true
    },
    onChangeIsModified: {
      type: Function,
      required: true,
    },
    config: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    content: null,
    types: null,
  }),
  computed: {        
    ...mapState('app', ['locale']),
    workspaceID () {
      return utils.getWorkspace('dtouch')
    },
  },
  watch: {
    editedItem () {
      this.prepareContent()
    },
  },
  mounted () {
    this.handleGetTypes()
    this.prepareContent()
  },
  methods: {
    prepareContent () {
      const aux = this.editedItem
      this.content = aux
    },
    handleChangeIsModified () {
      this.onChangeIsModified(this.content) 
    },
    handleGetTypes () {
      api.getAll('dtouch', `v1/private/workspaces/${this.workspaceID}/show-types`).then(response => {
        this.types = response.types
      })
    },
    handleChangePrimaryColor (v) {
      this.content.ShowPrimaryColor = v
      this.handleChangeIsModified()
    },
    handleChangeSecundaryColor (v) {
      this.content.ShowSecundaryColor = v
      this.handleChangeIsModified()
    },
    handleChangeTitleColor (v) {
      this.content.ShowColor = v
      this.handleChangeIsModified()
    },
    handleChangeDescriptionColor (v) {
      this.content.ShowDescriptionColor = v
      this.handleChangeIsModified()
    },
  },
}
</script>

